var React = require('react');

function PinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.50002 0C5.10516 0 2.34326 2.7619 2.34326 6.15672C2.34326 10.3698 7.85296 16.5548 8.08754 16.8161C8.30787 17.0615 8.69256 17.0611 8.9125 16.8161C9.14708 16.5548 14.6568 10.3698 14.6568 6.15672C14.6567 2.7619 11.8948 0 8.50002 0ZM8.50002 9.25434C6.79198 9.25434 5.40243 7.86476 5.40243 6.15672C5.40243 4.44869 6.79202 3.05914 8.50002 3.05914C10.208 3.05914 11.5976 4.44872 11.5976 6.15676C11.5976 7.86479 10.208 9.25434 8.50002 9.25434Z","fill":"#FF7629"}));
}

PinInline.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = PinInline;

PinInline.default = PinInline;
